import type { ProfileTranslations } from "../interfaces/profile";

export const profileTranslations: ProfileTranslations = {
  eyebrow: "Cuenta",
  page_title: "Mi Perfil",
  page_sub: "Información de tu cuenta y datos de contacto.",
  identity_title: "Tu perfil",
  identity_sub: "Esta información se muestra en los comprobantes y en el historial visto por tu equipo.",
  contact_section_title: "Información de Contacto",
  account_section_title: "Detalles de la Cuenta",
  email_label: "Email",
  phone_label: "Teléfono",
  country_label: "País",
  language_label: "Idioma",
  status_label: "Estado",
  two_factor_label: "Autenticación de dos factores",
  last_login_label: "Último inicio de sesión",
  two_factor_enabled: "Activada",
  two_factor_disabled: "Desactivada",
  not_specified: "No especificado",
};
